import { WifiSlash } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";

import { defaultIconProps } from "../features/shared/ui/icons";
import { useNetworkStatus } from "../providers/NetworkStatusProvider";

export function NetworkStatusBanner() {
  const { t } = useTranslation();
  const { isOnline } = useNetworkStatus();

  if (isOnline) {
    return null;
  }

  const Icon = WifiSlash;
  const message = t("network.offline_sync_banner");

  return (
    <div className="pointer-events-none fixed inset-x-0 top-0 z-40 flex justify-center px-4 pt-safe">
      <div className="pointer-events-auto flex w-full max-w-xl items-center gap-3 rounded-2xl border border-slate-200 bg-white/95 px-4 py-2 text-sm text-slate-700 shadow-lg backdrop-blur dark:border-slate-800 dark:bg-slate-900/95 dark:text-slate-200">
        <span className="inline-flex h-9 w-9 items-center justify-center rounded-2xl bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-200">
          <Icon {...defaultIconProps} aria-hidden />
        </span>
        <p className="flex-1">{message}</p>
      </div>
    </div>
  );
}
